import React from 'react';
import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'components/modals';
import HolidayNameInput from './HolidayNameInput';
import HolidayDateForm from './HolidayDateForm';
import HolidayDurationSelector from './HolidayDurationSelector';
import HolidayLocationSelector from './HolidayLocationSelector';

const HolidayModal = observer(({uiState}) => {
  const {currentHoliday, holidayModalOpen} = uiState;

  if (!currentHoliday) return null;

  return (
    <Modal
      onHide={() => uiState.closeHolidayModal()}
      size="md"
      isOpen={holidayModalOpen}
      title={currentHoliday.isNew ? 'time_off.holidays.Add Holiday' : 'time_off.holidays.Edit Holiday'}
    >
      <HolidayNameInput uiState={uiState}/>
      <HolidayDateForm uiState={uiState}/>
      <HolidayDurationSelector uiState={uiState}/>
      <HolidayLocationSelector uiState={uiState}/>
      <ModalButtons
        onCancel={() => uiState.closeHolidayModal()}
        onSave={() => uiState.saveHoliday()}
      />
    </Modal>
  );
});

export default HolidayModal;